import {ImagebProcesser} from "../process";
import {InputImage, ProcessedImage, ProcessedResult, ThresholdValueMode} from "../../types";
import {ImagebTool} from "../../tools";

export abstract class AbstractThreshold extends ImagebProcesser {

  threshold?: ThresholdValue;
  mode: ThresholdValueMode;

  protected constructor(
    threshold?: ThresholdValue,
  ) {
    super();
    this.mode = ThresholdValueMode.avg;
    this.threshold = threshold ?? new PinedThresholdValue();
  }

  process(input: InputImage): ProcessedResult {
    let result = ImagebTool.zeroAndOne(input);
    return new ProcessedResult({
      origin: input,
      result: new ProcessedImage({data: result, width: result.width, height: result.height})
    });

  }
}

export abstract class ThresholdValue {
  abstract threshold(): number;
}

export class PinedThresholdValue extends ThresholdValue {
  _value: number;

  constructor(value?: number) {
    super();
    this._value = value ?? 190;
  }

  threshold(): number {
    return this._value;
  }
}
